import { DialogHeading } from '@ariakit/react/dialog';

import SoleIcon from '~/assets/icons/Sole';

type Props = {
  children: JSX.Element | string;
};

const ModalHeadings = ({ children }: Props) => {
  return (
    <>
      <div className="flex max-h-[220px] min-h-[160px] flex-col items-center gap-4 pb-8 pt-4 text-center">
        <SoleIcon height="60" width="80" />
        <h2 className="font-display text-lg uppercase text-white md:text-2xl">
          Never Miss a Drop.
        </h2>
        <DialogHeading className="text-white">{children}</DialogHeading>
      </div>
    </>
  );
};

export default ModalHeadings;
